import * as Yup from 'yup';
import { PractitionerFilterType } from 'services/auth/__generated__/authHandleVerifyUserEmailMutation.graphql';

const isPractitionerFilterType = (value: any): value is PractitionerFilterType => {
  return ['COACH', 'THERAPIST'].includes(value);
};

export const v = {
  accountName: Yup.string()
    .min(2, 'Account name is too short')
    .max(100, 'Account name is too long')
    .required('Account name is required'),
  email: Yup.string().email().required('Email is required'),
  firstName: Yup.string().min(2).max(100).required('First name is required'),
  lastName: Yup.string().min(2).max(100).required('Last name is required'),
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Password is too short - should be 8 characters minimum')
    .max(24, 'Password is too long - should be 24 characters maximum')
    .matches(/^(?=.*[a-z])/, 'Password needs at least one lowercase letter')
    .matches(/^(?=.*[A-Z])/, 'Password needs at least one uppercase letter')
    .matches(/^(?=.*\d)/, 'Password needs at least one number')
    .matches(/^(?=.*[!@#$%^&*])/, 'Password needs at least one special character'),
  timeZone: Yup.object()
    .shape({
      label: Yup.string().required('Time zone is required'),
      value: Yup.string().required('Time zone is required'),
    })
    .required('Time zone is required'),
  practitionerType: Yup.string()
    .required('Practitioner type is required')
    .test('isValidPractitionerType', 'Invalid practitioner type', value => isPractitionerFilterType(value)),
  country: Yup.string().required('Country is required'),
};
